interface AddNewButtonProps {
  onClick: () => void;
  label?: string;
}

const AddNewButton = ({ onClick, label = "Add New" }: AddNewButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="shrink-0 px-10 py-[10px] rounded-[20px] text-white text-[16px] font-bold tracking-[0.64px] transition-opacity hover:opacity-90 bg-brand-accent"
  >
    {label}
  </button>
);

export default AddNewButton;
